import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardText,
  Row,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge
} from 'reactstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  getHistoryOfTransactions,
  deleteTransaction,
  refetchTransactionStatus
} from '../api/transaction';
import EdittransactionModal from '../pages/Child/EdittransactionModal';
import { connect } from 'react-redux';
import { UPDATE_TRANSACTION } from '../pages/Utility/PermissionKeys';
import { validatePermissionKey } from '../helpers/permission';
import SweetAlert from 'react-bootstrap-sweetalert';

const TransactionCard = ({ transaction, childDetail, refresh, authUser }) => {
  const [modal, setModal] = useState(false);
  const [history, setHistory] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [finalAmountPaid, setFinalAmountPaid] = useState(0);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: '',
    type: 'success'
  });
  const [refetchLoading, setRefetchLoading] = useState(false);
  const toggleModal = () => {
    callHistory();
    setModal(!modal);
  };

  const tableStyle = {
    // border: '0.5px solid gray',
    borderCollapse: 'collapse',
    width: '100%'
  };

  const headerStyle = {
    backgroundColor: '#3AA6AE',
    color: 'white'
  };

  const rowStyleEven = {
    backgroundColor: 'white'
  };

  const rowStyleOdd = {
    backgroundColor: '#EAF6F6'
  };

  const cellStyle1 = {
    border: 'none',
    textAlign: 'right'
  };

  const cellStyle2 = {
    border: 'none'
    // textAlign:'right'
  };

  const {
    date,
    dueAmount,
    totalAmountToPay,
    paidAmount,
    batchId,
    isSessionBatch,
    registeredSessions,
    invoiceDetail,
    madeBy,
    discountAmount,
    discountType,
    address,
    quarter,
    isPaid,
    penaltyAmount
  } = transaction;
  useEffect(() => {
    let final = Number(paidAmount);
    if (!!discountAmount) {
      final -= Number(discountAmount);
    }
    if (!!penaltyAmount) {
      final += Number(penaltyAmount);
    }

    setFinalAmountPaid(final);
  }, [paidAmount, discountAmount, penaltyAmount]);

  const formattedDate = new Date(date).toLocaleDateString();
  const formattedTime = new Date(date).toLocaleTimeString();

  let formattedUserType;

  if (madeBy) {
    formattedUserType = madeBy?.user_type
      ? madeBy?.user_type
        ?.replace('_', ' ')
        ?.replace(/\b\w/g, (c) => c.toUpperCase())
      : '';
  }

  const downloadInvoice = () => {
    const input = document.getElementById('invoice');
    const scale = 2;
    html2canvas(input, { scale }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice_${batchId.name}.pdf`);
    });
  };

  const callHistory = async () => {
    const response = await getHistoryOfTransactions({
      child_id: childDetail?._id,
      batch_id: batchId?._id
    });
    setHistory(response?.data);
  };

  const handleDeleteTxn = async () => {
    setConfirmDelete(false);
    try {
      const res = await deleteTransaction(transaction?._id);
      if (res?.error) {
        setAlertMessage({
          open: true,
          message: res.error,
          type: 'error'
        });
        return;
      } else {
        setAlertMessage({
          open: true,
          message: 'Transaction deleted successfully',
          type: 'success'
        });
      }
    } catch (error) {
      console.error('Error deleting transaction:', error);
    }
  };

  const handleRefreshStatus = async (id) => {
    setRefetchLoading(true);
    const response = await refetchTransactionStatus(id);
    if (response?.error) {
      setAlertMessage({
        open: true,
        message: response?.error,
        type: 'error'
      });
      setRefetchLoading(false);
      return;
    } else {
      setAlertMessage({
        open: true,
        message: 'Transaction status refreshed successfully',
        type: 'success'
      });
    }
    setRefetchLoading(false);
  };

  // Helper to extract paid date from transaction logs
  const getPaidDate = (item) => {
    if (!item.transactionLogs || !Array.isArray(item.transactionLogs)) return '';
    const successLog = item.transactionLogs.find(log => log.status === 'success');
    if (!successLog || !successLog.timestamp) return '';
    return new Date(successLog.timestamp).toLocaleDateString('en-GB'); // DD/MM/YYYY
  };


  return (
    <div>
      {alertMessage.open && (
        <SweetAlert
          danger={alertMessage.type === 'error' ? true : false}
          success={alertMessage.type === 'success' ? true : false}
          title={alertMessage.type === 'success' ? "Updated" : "Error"}
          onConfirm={() => {
            setAlertMessage({
              open: false,
              message: '',
              type: 'success'
            });
            refresh();
          }}
        >
          {alertMessage.message}
        </SweetAlert>
      )}

      {confirmDelete && (
        <SweetAlert
          warning
          showCancel
          confirmBtnText="Confirm"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDeleteTxn}
          onCancel={() => setConfirmDelete(false)}
          focusCancelBtn
        >
          This will permanently delete the transaction and this action cannot be
          undone.
        </SweetAlert>
      )}
      <EdittransactionModal
        modalOpenState={editModal}
        closeModalHandler={() => setEditModal((prev) => !prev)}
        data={transaction}
        childId={childDetail?._id}
        childinfo={childDetail}
        refresh={refresh}
      />
      <Card className="my-3">
        <CardBody>
          <Row className="mb-1 ml-2 d-flex justify-content-between align-items-center">
            <Col className="text-left" md={6}>
              <Row>
                <strong>
                  <i className="bi bi-file-earmark-text"></i> Invoice ID:
                </strong>{' '}
                {transaction?.InvoiceID}
              </Row>
              <Row>
                <strong>
                  <i className="bi bi-calendar-event"></i> Date:{' '}
                </strong>{' '}
                {' ' + formattedDate} {formattedTime}
              </Row>
              <Row>
                <Badge
                  className="mr-2"
                  style={{
                    backgroundColor: isPaid === false ? '#e57373' : '#28a745',
                    padding: '0.5em 1em',
                    marginTop: '5px'
                  }}
                >
                  {isPaid === false ? 'Unpaid Transaction' : 'Paid Transaction'}
                </Badge>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="justify-content-end">
                <Col className="text-right">
                  {isPaid ? (
                    <Button
                      size="sm"
                      color="primary"
                      className="waves-effect waves-light mr-2 mb-2"
                      onClick={toggleModal}
                    >
                      View Invoice
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      color="danger"
                      className="waves-effect waves-light mr-1 mb-2"
                      onClick={() => setConfirmDelete(true)}
                    >
                      <i className="ri-delete-bin-line align-middle mr-2"></i>
                      Delete
                    </Button>
                  )}
                </Col>
                {(authUser.user_type === 'super_admin' ||
                  validatePermissionKey(authUser, UPDATE_TRANSACTION)) ? (
                  <Button
                    size="sm"
                    color="warning"
                    className="waves-effect waves-light mr-2 mb-2"
                    onClick={() => {
                      setEditModal((prev) => !prev);
                    }}
                    disabled={isPaid && !transaction?.isCashPayment}
                  >
                    <i className="fas fa-edit mr-2"></i>
                    Edit
                  </Button>
                ) : null}
                {isPaid === false && <Button
                  size="sm"
                  color="info"
                  className="waves-effect waves-light mr-2 mb-2"
                  onClick={() => handleRefreshStatus(transaction?._id)}
                  disabled={refetchLoading}
                >
                  {/* <i className="fas fa-edit mr-2"></i> */}
                  {refetchLoading ? "Refreshing..." : "Refresh Status"}
                </Button>}
              </Row>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col className="text-left"></Col>
          </Row>

          <CardText>
            <Row>
              <Col
                md="6"
                sm="12"
                className="form-control my-1 mx-3"
                style={{
                  backgroundColor: isSessionBatch ? 'pink' : 'greenyellow'
                }}
              >
                <strong> Batch Type:</strong>{' '}
                {isSessionBatch ? 'Session Batch' : 'Normal Batch'}
              </Col>
              <Col md="5" className="form-control my-1 mx-3" sm="12">
                <strong> Batch Name:</strong> {batchId.name}
              </Col>

              {transaction?.isSessionBatch ? (
                <>
                  <Col md="6" className="form-control my-1 mx-3" sm="12">
                    <strong>
                      <i className="bi bi-currency-rupee"></i> Total Fees (Reg
                      Session x Per Session Fee):
                    </strong>{' '}
                    Rs. {registeredSessions * transaction?.perSessionFee}
                  </Col>
                  <Col md="5" sm="12" className="form-control my-1 mx-3">
                    <strong>
                      <i className="bi bi-calendar-range"></i> Per Session Fees:
                    </strong>{' '}
                    Rs. {transaction?.perSessionFee}
                  </Col>
                  {registeredSessions && (
                    <Col md="6" className="form-control my-1 mx-3" sm="12">
                      <strong>
                        <i className="bi bi-list-check"></i> Registered
                        Sessions:
                      </strong>{' '}
                      {registeredSessions}
                    </Col>
                  )}
                </>
              ) : quarter !== undefined || quarter !== null ? (
                <>
                  {/* For new quarterly transactions */}
                  <Col md="6" className="form-control my-1 mx-3" sm="12">
                    <strong>Quarter Started On : </strong>{' '}
                    {quarter !== undefined || quarter !== null
                      ? new Date(
                        batchId.quarters[quarter - 1]?.month
                      ).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'long'
                      })
                      : 'N/A'}
                  </Col>
                  <Col md="5" className="form-control my-1 mx-3" sm="12">
                    <strong>
                      <i className="bi bi-currency-rupees"></i> Quarter Fees :
                    </strong>{' '}
                    Rs. {totalAmountToPay.toFixed(2)}
                  </Col>
                  <Col md="6" className="form-control my-1 mx-3" sm="12">
                    <strong>
                      <i className="bi bi-currency-rupees"></i> Total Fees :
                    </strong>{' '}
                    Rs. {batchId.totalFee}
                  </Col>
                </>
              ) : (
                // For previous non-quarterly transactions
                <Col md="6" className="form-control my-1 mx-3" sm="12">
                  <strong>
                    <i className="bi bi-currency-rupees"></i> Total Fees :
                  </strong>{' '}
                  Rs. {totalAmountToPay}
                </Col>
              )}

              <Col md="5" className="form-control my-1 mx-3" sm="12">
                <strong>
                  <i className="bi bi-exclamation-circle"></i> Due Amount:
                </strong>{' '}
                ₹
                {isSessionBatch
                  ? transaction.isPaid
                    ? 0
                    : registeredSessions * transaction?.perSessionFee -
                    (transaction.discountAmount || 0)
                  : dueAmount}
              </Col>

              <Col md="6" className="form-control my-1 mx-3" sm="12">
                <strong>{discountType || 'Promotional'} Discount:</strong> ₹
                {discountAmount}
              </Col>
              {/* <Col md="5" className="form-control my-1 mx-3" sm="12">
                <strong>Late Fee Penalty:</strong> ₹{Number(penaltyAmount || 0)}{' '}
                {
                  penaltyAmount > 0 && (
                    `(${batchId[`quarter${quarter}`]?.penalty_percentage}% of Quarter Fee)`
                  )
                }
              </Col> */}

              <Col className="form-control my-1 mx-3" md="5">
                <strong>
                  {isPaid ? 'Final Paid Amount' : 'Final Amount to Pay'}:
                </strong>{' '}
                ₹
                {isPaid
                  ? transaction?.isSessionBatch
                    ? Number(transaction?.perSessionFee) *
                    Number(registeredSessions || 0) -
                    Number(discountAmount || 0)
                    : Number(paidAmount.toFixed(2) || 0)
                  : transaction?.isSessionBatch
                    ? (Number(transaction?.perSessionFee) *
                      Number(registeredSessions || 0) -
                      Number(discountAmount || 0)).toFixed(2)
                    : (Number(totalAmountToPay || 0)).toFixed(2)}
              </Col>
            </Row>
            {/* {invoiceDetail && invoiceDetail.length > 0 && (
              <Row className="my-3">
                <Col>
                  <Table bordered style={{ border: '1px solid' }}>
                    <thead>
                      <tr>
                        <th>Description</th>
                        <th>Rate</th>
                        <th>Quantity</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceDetail.map((item, index) => (
                        <tr key={index}>
                          <td>{item.description}</td>
                          <td>₹{item.rate}</td>
                          <td>{item.quantity}</td>
                          <td>₹{item.price}</td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td></td>
                        <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                          Initial Amount
                        </td>
                        <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                          ₹{paidAmount}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                          {discountType ? discountType : 'Promotional'} Discount
                        </td>
                        <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                          -₹{discountAmount ? discountAmount : 0}
                        </td>
                      </tr>
                      {!!penaltyAmount && penaltyAmount > 0 && (
                        <tr>
                          <td></td>
                          <td></td>
                          <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                            Late Payment Penalty (
                            {batchId[`quarter${quarter}`]?.penalty_percentage}
                            %)
                          </td>
                          <td style={{ borderBottom: '1px solid #3AA6AE' }}>
                            +₹{penaltyAmount || 0}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Final Amount Paid</td>
                        <td>₹{finalAmountPaid || 0}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            )} */}
            {madeBy ? (
              <Row className="mt-3">
                <Col>
                  <Card className="border-1">
                    <CardBody>
                      <h6 className="mb-3">Transaction Made By:</h6>
                      <Table bordered>
                        <thead>
                          <tr>
                            <td>Name</td>
                            <td>Email</td>
                            <td>Designation</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {/* <td><strong>Name:</strong></td> */}
                            <td>{madeBy.name}</td>
                            {/* <td><strong>Email:</strong></td> */}
                            <td>{madeBy.email}</td>
                            {madeBy.user_type && <td>{formattedUserType}</td>}
                          </tr>
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            ) : null}
          </CardText>
        </CardBody>
      </Card>

      <Modal isOpen={modal} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal}>Invoice</ModalHeader>
        <ModalBody>
          <div id="invoice">
            <div
              style={{
                backgroundColor: '#3AA6AE',
                height: '20px',
                width: '100%'
              }}
            ></div>
            <div
              style={{
                width: '100%',
                margin: '0 auto',
                padding: '20px',
                border: '1px outset #ccc'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap'
                }}
              >
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '180px', height: '180px' }}>
                    <img
                      src="/rr_ico.png"
                      alt="Raising Right Logo"
                      style={{ height: '100%', width: '100%' }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'inline-block',
                      paddingTop: '20px',
                      paddingRight: '10px'
                    }}
                  >
                    <h2>Raising Right</h2>
                    <i style={{ fontSize: 14 }}>
                      {address
                        ? address
                        : '5, Kamla Nagar, M.G. Road, Kandivali West'}
                      <br />
                      Mumbai, MH 400067
                    </i>
                    <p style={{ fontSize: 14 }}>
                      8355953059
                      <br />
                      raisingright.education
                      <br />
                      raisingrightpreschool@gmail.com
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingRight: '20 px',
                      textAlign: 'left'
                    }}
                  >
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        INVOICE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {transaction?.InvoiceID}
                      </p>
                    </span>
                    {/* Added Batch Name Section */}
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BATCH NAME
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {batchId.name}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BATCH TIMING
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {batchId?.start_time} - {batchId?.end_time}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        DATE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        {formattedDate} {formattedTime}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        TOTAL FEES
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        INR ₹
                        {isSessionBatch
                          ? registeredSessions * transaction?.perSessionFee
                          : batchId?.totalFee}
                      </p>
                    </span>
                    <span>
                      <p
                        style={{
                          fontSize: '16px',
                          textAlign: 'end',
                          fontWeight: 'bold',
                          margin: 0,
                          padding: 0
                        }}
                      >
                        BALANCE DUE
                      </p>
                      <p style={{ fontSize: '13px', textAlign: 'end' }}>
                        INR ₹{Math.round(transaction?.dueAmount - transaction?.totalAmountToPay)}
                      </p>
                    </span>
                    {transaction?.transactionId && (
                      <span>
                        <p
                          style={{
                            fontSize: '16px',
                            textAlign: 'end',
                            fontWeight: 'bold',
                            margin: 0,
                            padding: 0
                          }}
                        >
                          TRANSACTION ID
                        </p>
                        <p style={{ fontSize: '13px', textAlign: 'end' }}>
                          {transaction?.transactionId}
                        </p>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  margin: '10px 0px 5px 0px'
                }}
              >
                <div>
                  <p>BILL TO</p>
                  <h4>{childDetail.name}</h4>
                  <i>{childDetail.address}</i>
                  <p>
                    {childDetail.phone_number}
                    <br />
                    {childDetail.email_address}
                  </p>
                </div>
              </div>
              <div>
                <Table style={tableStyle}>
                  <thead>
                    <tr style={headerStyle}>
                      <th style={cellStyle2}>DESCRIPTION</th>
                      <th style={cellStyle1}>RATE</th>
                      <th style={cellStyle1}>QTY</th>
                      <th style={cellStyle1}>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceDetail.map((item, index) => (
                      <tr
                        key={index}
                        style={index % 2 === 0 ? rowStyleEven : rowStyleOdd}
                      >
                        <td style={cellStyle2}>{item.description}</td>
                        <td style={cellStyle1}>₹{item.rate}</td>
                        <td style={cellStyle1}>{item.quantity}</td>
                        <td style={cellStyle1}>₹{item.price}</td>
                      </tr>
                    ))}
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        Initial Amount
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {transaction?.totalAmountToPay}
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {discountType ? discountType : 'Promotional'} Discount
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        -₹{discountAmount ? discountAmount : 0}
                      </td>
                    </tr>
                    {!!penaltyAmount && penaltyAmount > 0 && (
                      <tr>
                        <td style={cellStyle1}></td>
                        <td style={cellStyle1}></td>
                        <td
                          style={{
                            borderTop: '2px solid #CDE9EA ',
                            textAlign: 'right'
                          }}
                        >
                          Late Payment Penalty (
                          {batchId[`quarter${quarter}`]?.penalty_percentage}
                          %)
                        </td>
                        <td
                          style={{
                            borderTop: '2px solid #CDE9EA ',
                            textAlign: 'right'
                          }}
                        >
                          +₹{penaltyAmount || 0}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        <b>Total Paid</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        ₹{transaction?.paidAmount || 0}
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        <b>Past Paid Amount</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right'
                        }}
                      >
                        {' '}
                        ₹
                        {transaction?.isSessionBatch
                          ? transaction?.perSessionFee * registeredSessions -
                          paidAmount -
                          dueAmount
                          : history[0]?._id?.toString() ===
                            transaction?._id?.toString()
                            ? 0
                            : (history[0]?.paidAmount || 0)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td style={cellStyle1}></td>
                      <td style={cellStyle1}></td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right',
                          backgroundColor: '#CDE9EA'
                        }}
                      >
                        <b>Balance Due</b>
                      </td>
                      <td
                        style={{
                          borderTop: '2px solid #CDE9EA ',
                          textAlign: 'right',
                          backgroundColor: '#CDE9EA'
                        }}
                      >
                        INR ₹{Math.round(transaction?.dueAmount - transaction?.totalAmountToPay)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <h4 style={{ textAlign: 'center', color: 'grey', marginTop: 20 }}>
              Transaction History
            </h4>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0px 20px'
              }}
            >
              {history.length <= 0 ? <p>No previous transactions!</p> : null}
              {history.length > 0 && (
                <table
                  style={{
                    borderStyle: 'outset',
                    borderWidth: '0.1px',
                    borderColor: '#078691',
                    width: '100%',
                    margin: '15px 35px'
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Transaction ID
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Due Date (DD/MM/YYYY)
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Paid Date
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Amount Paid
                      </th>
                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                        Due Amount
                      </th>
                      {history.some((item) => item?.isSessionBatch) && (
                        <th style={{ fontWeight: 'bold', textAlign: 'center' }}>
                          Registered Sessions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {history.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          borderStyle: 'solid',
                          borderWidth: '0.1px',
                          padding: '5px',
                          borderColor: '#078691',
                          backgroundColor: item?.isPaid ? '#F5F5F5' : '#CDE9EA'
                        }}
                      >
                        <td style={{ textAlign: 'center' }}>
                          <strong>{item?.InvoiceID}</strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <strong>
                            {new Date(item?.dueDate).toLocaleDateString(
                              'en-GB'
                            )}
                          </strong>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {getPaidDate(item)}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item?.paidAmount !== 0 && 'INR'}{' '}
                          {item?.paidAmount === 0
                            ? `Next Payment (INR ${item?.totalAmountToPay +
                            item?.penaltyAmount -
                            item?.discountAmount
                            })`
                            : item?.paidAmount}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          INR {item?.dueAmount}
                        </td>
                        {item?.isSessionBatch && (
                          <td style={{ textAlign: 'center' }}>
                            {item?.registeredSessions}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* Added Red Note Section */}
            <div
              style={{
                color: 'red',
                textAlign: 'center',
                margin: '20px 0',
                fontWeight: 'bold',
                fontSize: '14px',
                // border: '1px solid red',
                padding: '10px'
                // backgroundColor: '#fff0f0'
              }}
            >
              Note: In case of any cancellation, instalment already paid are
              strictly not refundable. After due date of each instalment late
              fee will be applicable.
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={downloadInvoice}>
            Download Invoice
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(TransactionCard);
